import { render } from "./ErrorComponent.vue?vue&type=template&id=7c92449a&scoped=true"
import script from "./ErrorComponent.vue?vue&type=script&lang=js"
export * from "./ErrorComponent.vue?vue&type=script&lang=js"

import "./ErrorComponent.vue?vue&type=style&index=0&id=7c92449a&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c92449a"]])

export default __exports__